import { api_ } from '@shared/plugIn/axios';

import { GiftDeliveryZonePolicy } from '../giftItemBrand/giftItemBrand.interface';

export interface DeliveryZoneRow {
  rowNumber?: number;
  sido: string;
  sigungu: string;
  emd: string;
  extraFee: number;
  deliverable: boolean;
}
export interface DeliveryZoneSearch {
  giftItemBrand: string;
  q?: string;
  sido?: string;
  deliverable?: string;
  minExtraFee?: string;
  skip?: number;
  limit?: number;
}
export interface DeliveryZoneList {
  items: (DeliveryZoneRow & { _id: string })[];
  count: number;
  summary: { total: number; enabled: number; disabled: number };
  sidos: string[];
}
export interface DeliveryZoneImportReport {
  valid: boolean;
  rowsIn: number;
  keys: number;
  errors: { row: number; message: string }[];
  duplicates: number;
  created: number;
  changed: number;
  unchanged: number;
  preservedDisabled: number;
  disabled: number;
  retired: number;
}
export interface DeliveryZoneImport {
  giftItemBrand: string;
  rows: DeliveryZoneRow[];
  file?: string;
  retireMissing: boolean;
  restoreDisabled: boolean;
  dryRun: boolean;
}
const root = '/admin/gift-delivery-zone';
export const listAdminDeliveryZones = async (params: DeliveryZoneSearch) =>
  (await api_.get<DeliveryZoneList>(`${root}/search`, { params })).data;
export const importAdminDeliveryZones = async (payload: DeliveryZoneImport) =>
  (await api_.post<DeliveryZoneImportReport>(`${root}/import`, payload)).data;
export const saveAdminDeliveryZone = async (
  giftItemBrand: string,
  row: DeliveryZoneRow,
) => (await api_.post(`${root}/save`, { giftItemBrand, row })).data;
export interface ZoneCheckAddress {
  sido: string;
  sigungu: string;
  bname: string;
  bname1?: string;
  hname?: string;
}
export interface ZoneCheckResult {
  deliverable: boolean;
  reason?: string;
  baseFee: number;
  extraFee: number;
  total: number;
  rule: { fee: number; freeOverAmount: number } | null;
  zone: { sido: string; sigungu: string; emd: string } | null;
}
export const previewAdminDeliveryFee = async (payload: {
  giftItemBrand: string;
  policy?: GiftDeliveryZonePolicy;
  address: ZoneCheckAddress;
  subtotal: number;
}) => (await api_.post<ZoneCheckResult>(`${root}/preview`, payload)).data;

export function deliveryZoneError(error: unknown): string {
  const e = error as {
    response?: { data?: { message?: string | string[] } };
    message?: string;
  };
  const message = e.response?.data?.message;
  return Array.isArray(message)
    ? message.join('\n')
    : message ?? e.message ?? '처리하지 못했습니다. 다시 시도해 주세요.';
}

// 정산정보 조회 화면: 관리 API와 달리 정책 입력/저장 기능을 노출하지 않는다.
export const listBrandDeliveryZones = async (params: DeliveryZoneSearch) =>
  (
    await api_.get<DeliveryZoneList>('/gift-brand-seller/gift-delivery-zone/search', {
      params,
    })
  ).data;
export const previewBrandDeliveryFee = async (payload: {
  giftItemBrand: string;
  address: ZoneCheckAddress;
  subtotal: number;
}) =>
  (
    await api_.post<ZoneCheckResult>(
      '/gift-brand-seller/gift-delivery-zone/preview',
      payload,
    )
  ).data;
